<template>
    <div class="modal fade" id="walleteditstackModal" tabindex="-1" aria-labelledby="WalletModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content wallet-edit-stake-modal">
                <div class="modal-header headerTheme">
                    <h3>{{ $t('edit-stake', 'Edit Stake') }}</h3>
                </div>
                <div class="modal-body">
                    <div class="singlestakeed-wallet">
                        <input v-model="stake[i-1]" v-for="i in 4" class="btn-thm m-auto" maxlength="8" @input="stake[i-1] = $helper.sanitizeNumber(stake[i-1], 10000000)">
                    </div>
                    <div class="header-but info-footer">
                        <button type="button" class="thm-but thm-bor-but" data-bs-dismiss="modal" @click="resetChips()">
                            {{ $t('cancel', 'Cancel') }}
                        </button>
                        <a class="thm-but stake-save-btn" @click="callChangeStakeValue()">
                            {{ $t('save', 'Save') }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "WalletStackModal",
    props: ['stakes'],
    data() {
        return {
            stake: JSON.parse(JSON.stringify(this.$store.getters.userTransactionStakes || this.stakes))
        };
    },
    mounted() {
        this.resetChips();
    },
    methods: {
        callChangeStakeValue() {
            if(Object.values(this.stake).some(item => item == '') || Object.values(this.stake).some(item => item < 100)){
                this.$errorToast('Stake value must be between 100 to 1Cr.')
                return

            }
            this.$store.dispatch('setUserTransactionStakes', JSON.parse(JSON.stringify(this.stake)));
            this.$successToast('Saved Successfully')
            this.$helper.closeModal('walleteditstackModal');
        },
        resetChips() {
            this.stake = JSON.parse(JSON.stringify(this.$store.getters.userTransactionStakes || this.stakes));
        }
    }
};
</script>
<style>
.stake-save-btn {
    opacity: 1 !important;
}
</style>